<template>
  <button v-if="isApprenticeship" type="button" class="btn btn-tertiary otj-button" @click="openQuickAdd" ref="otjButton">
    <i class="fas fa-clock" aria-hidden="true"></i>
    <span>Add O.T.J</span>
  </button>
</template>

<style scoped>
button > i {
  margin-right: 10px;
}

.otj-button:focus {
  background-color: var(--kate-button-tertiary);
  color: var(--kate-type-light);
}
</style>

<script>
import useAppProgrammeStore from '@stores/app-programme-store';
import useOtjModalStore from '@stores/otj-modal-store';

export default {
  data() {
    return {
      otjModalStore: useOtjModalStore(),
      appProgrammeStore: useAppProgrammeStore(),
    };
  },
  computed: {
    isApprenticeship() {
      return this.appProgrammeStore.currentProgramme?.is_apprenticeship;
    },
    programmeId() {
      return this.appProgrammeStore.currentProgrammeId;
    },
    isOtjModalOpen() {
      return this.otjModalStore.isOtjModalOpen;
    },
  },

  methods: {
    openQuickAdd() {
      if (!this.isOtjModalOpen) {
        this.otjModalStore.openOtjModal(this.programmeId);
      }
    },
  },
};
</script>
